import { userAxios } from '../index'

const appointmentList = async (perPage) => {
    try {
        return await userAxios.get(`consultation/all/${perPage}`).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const appointmentDetail = async (id) => {
    try {
        return await userAxios.get(`consultation/${id}`).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const appointmentCreate = async (data) => {
    try {
        return await userAxios.post('consultation', data).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const appointmentUpdate = async (id, data) => {
    try {
        return await userAxios.put(`consultation/${id}`, data).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const appointmentDelete = async (id) => {
    try {
        return await userAxios.delete(`consultation/${id}`).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const appointmentPagination = async (perPage, page) => {
    try {
        return await userAxios.get(`consultation/all/${perPage}?page=${page}`).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const appointmentFilter = async (perPage, data) => {
    try {
        return await userAxios.post(`officeVisits/search/${perPage}`, data).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const appointmentFilterPagination = async (perPage, page, data ) => {
    try {
        return await userAxios.post(`officeVisits/search/${perPage}?page=${page}`, data).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const getScheduledAppointments = async () => {
    try {
        return await userAxios.get('users/patients/get-scheduled-appointments').then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

const updateScheduledAppointmentStatus = async (id, status_visit) => {
    try {
        return await userAxios.post(`users/patients/update-scheduled-appointments/${id}`, {
            status_visit,
        }).then(res => res.data)
    } catch (error) {
        console.log(error);
    }
}

/**
 * Acepta una solicitud del agente y fija el tipo de visita del carril regular.
 * POST users/patients/update-scheduled-appointments/{id}
 * @param {number} id
 * @param {number} typeVisitsId
 */
const acceptScheduledAppointment = async (id, typeVisitsId) => {
    const response = await userAxios.post(`users/patients/update-scheduled-appointments/${id}`, {
        status_visit: 1,
        type_visits_id: Number(typeVisitsId),
    })
    return response.data
}

/**
 * Actualiza una solicitud de cita (visit_date y/o status_visit).
 * Útil para reasignar cita cuando ya pasó la hora original.
 * @param {number} id - ID de la solicitud
 * @param {Object} data
 * @param {number} [data.status_visit] - 0=pending, 1=accepted, 2=cancelled
 * @param {string} [data.visit_date] - Nueva fecha/hora (formato MM-DD-YYYY HH:mm:ss)
 */
const updateScheduledAppointment = async (id, data) => {
    try {
        const body = {}
        if (data.status_visit !== undefined) body.status_visit = data.status_visit
        if (data.visit_date) body.visit_date = data.visit_date
        return await userAxios.post(`users/patients/update-scheduled-appointments/${id}`, body).then(res => res.data)
    } catch (error) {
        console.error('Error updating scheduled appointment:', error)
        throw error
    }
}

/**
 * Crea una solicitud de cita (aparece en Calendario > Requests).
 * El paciente/miembro solicita cita; la clínica la acepta o rechaza.
 * @param {Object} data
 * @param {number} data.patient_id - ID del paciente
 * @param {number} data.facility_id - ID de la facility
 * @param {string} data.date - Fecha (formato esperado por backend)
 */
const createScheduledAppointment = async (data) => {
    try {
        const formData = new FormData()
        formData.append('patient_id', data.patient_id.toString())
        formData.append('facility_id', data.facility_id.toString())
        formData.append('date', data.date)
        return await userAxios.post('users/patients/create-scheduled-appointments', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).then(res => res.data)
    } catch (error) {
        console.error('Error creating scheduled appointment request:', error)
        throw error
    }
}

export default {
    appointmentList,
    appointmentDetail,
    appointmentCreate,
    appointmentUpdate,
    appointmentDelete,
    appointmentPagination,
    appointmentFilter,
    appointmentFilterPagination,
    getScheduledAppointments,
    updateScheduledAppointmentStatus,
    acceptScheduledAppointment,
    updateScheduledAppointment,
    createScheduledAppointment,
}